<template>
  <nav class="tg-pagination">
    <tg-button
      class="btn-lastPage"
      round
      border
      @click.native="goPage(1)"
      :disabled="currentPage == 1"
    >
      {{ $t("component.pagination.firstPage") }}
    </tg-button>
    <ul class="pagination">
      <li class="page-item prev" v-show="showPrevBtn">
        <a class="page-link" @click="goPage(currentPage - 1)">prev</a>
      </li>
      <li
        v-for="(page, index) in pages"
        :key="index"
        v-bind:class="{ 'page-item': true, active: page === currentPage }"
      >
        <a
          class="page-link"
          @click="goPage(page)"
          :disabled="page === currentPage"
          >{{ page }}</a
        >
      </li>
      <li class="page-item next" v-show="showNextBtn">
        <a class="page-link" @click="goPage(currentPage + 1)">next</a>
      </li>
    </ul>
    <tg-button
      class="btn-lastPage"
      round
      border
      @click.native="goPage(totalPage)"
      :disabled="totalPage == 1"
    >
      {{ $t("component.pagination.lastPage") }}
    </tg-button>
    <p v-if="showPerPage">
      {{ $t("component.pagination.perPage") }}
      <tg-dropdown
        :items="perPages"
        :value="value"
        @on-change="perPageSelectHandler"
        trigger="click"
      ></tg-dropdown>
      {{ $t("component.pagination.count") }}&ensp;
    </p>
    <p>{{ $t("component.pagination.total", { total: totalPage }) }}</p>
    <div class="inline-formGroup">
      {{ $t("component.pagination.goto") }}
      <el-input
        type="number"
        v-model="inputPage"
        placeholder
        class="tg-input pagination-num"
        size="small"
      ></el-input>
      {{ $t("component.pagination.page") }}
      <tg-button
        round
        :classes="['tg-btn--confirm']"
        @click.native="goPage(inputPage)"
        >{{ $t("component.btn.go") }}</tg-button
      >
    </div>
  </nav>
</template>

<script>
import TgDropdown from "@/components/dropdown/TgDropdown";
import TgButton from "@/components/button/TgButton";

export default {
  name: "TgPagination",
  components: {
    TgDropdown,
    TgButton,
  },
  data: () => {
    return {
      inputPage: null,
      currentPage: 1,
      currentPerPage: 10,
    };
  },
  props: {
    page: {
      type: Number,
      default: 1,
    },
    totalPage: {
      type: Number,
      default: 1,
    },
    totalCount: {
      type: Number,
      default: null,
    },
    perPages: {
      type: Array,
      default() {
        return [
          {
            label: 10,
            value: 10,
            active: true,
          },
          {
            label: 20,
            value: 20,
          },
          {
            label: 50,
            value: 50,
          },
        ];
      },
    },
    value: Number,
    showPerPage: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
  created() {
    if (this.value) {
      this.currentPerPage = this.value;
    }
  },
  computed: {
    showNextBtn() {
      return this.currentPage !== this.totalPage;
    },
    showPrevBtn() {
      return this.currentPage !== 1;
    },
    /**
     * 頁碼產生
     */
    pages() {
      // 先取4個range
      // 後面比較好處理
      let pages = [
        this.currentPage - 1,
        this.currentPage,
        this.currentPage + 1,
        this.currentPage + 2,
      ];

      // 第一頁，捨去 0
      if (this.currentPage === 1) {
        pages = pages.slice(1);
      }

      let i = 0;
      while (pages[i] < 1) {
        pages.slice(i + 1);
      }

      // 輸入保護 最小值為 1
      if (pages[0] < 1) {
        pages[0] = 1;
      }

      while (pages.length < 3) {
        if (pages[1] < this.totalPage) {
          pages.push(pages[pages.length - 1] + 1);
        } else if (pages[1] === this.totalPage) {
          pages.reverse();
          pages.push(pages[1] - 1);
          pages.reverse();
        }
      }

      // 輸入保護 最大值
      if (pages[1] > this.totalPage) {
        pages = pages.slice(0, 1);
      }

      if (pages[2] > this.totalPage) {
        pages = pages.slice(0, 2);
      }

      // 一次最多顯示三頁
      return pages.slice(0, 3);
    },
  },
  methods: {
    /**
     * 分頁數量切換
     *
     * @return  {void}}
     */
    perPageSelectHandler(item) {
      this.currentPerPage = item.value;
      this.$emit("perPageChanged", { perPage: item.value });
    },
    goPage(page) {
      page = parseInt(page);
      page = page < 0 ? 1 : page;

      // 輸入保護
      if (!page || page === 0 || page > this.totalPage) {
        this.inputPage = null;
        return;
      }

      let event = {
        page: page,
        currentPerPage: this.currentPerPage,
        currentPage: this.currentPage,
        pagination: this,
      };

      this.$emit("beforePageChange", event);

      // beforePageChange 可能會改變page值
      page = event.page;

      this.currentPage = page;
      this.inputPage = null;
      this.$emit("pageChanged", {
        page: page,
      });
    },
  },
  watch: {
    page(value) {
      if (this.currentPage !== value) {
        // 此處不使用goPage；避免外部指派後，又產生emit('pageChanged')
        this.currentPage = value;
      }
    },
    value(val) {
      this.currentPerPage = val;
    },
  },
};
</script>
